<template>
  <div class="home" :class="{ editHome: isHomeEdit }">
    <div id="watermark"></div>
    <div id="home" v-if="$store.state.isHome">
      <!-- 图表 -->
      <div id="home-canvas"></div>
      <!-- 首页内容 -->
      <home-container :class="{ homeEdit: isHomeEdit }" :isHomeEdit="isHomeEdit"></home-container>
      <!-- 机器信息 -->
      <machine-tip v-for="(k, i) in machineList" :key="i" :machineList="machineList[i]" :machineKey="i"
        :isHomeEdit="isHomeEdit"></machine-tip>
      <!-- 切换机器按钮 -->
      <div id="cMachine" class="switchMachine1" :class="{ switchMachine2: switchMachine }" v-show="isHomeEdit">
        <div @click="switchMachineFn1">叠片机</div>
        <div @click="switchMachineFn2">卷绕机</div>
      </div>
      <!-- 有无车间 -->
      <div class="shade-btn" v-show="!isHomeEdit">
        <div :class="{ shade: !isShade }" @click="shadeFn">无车间</div>
        <div :class="{ shadeShow: isShade }" @click="shadeShowFn">有车间</div>
      </div>
    </div>
    <!-- 头部 -->
    <home-header :title="title" :user-info="userData" @headTabFn="getHomeModel" @sendValue="handleChildValue"
      @userFn="userFn" @getchartData="getChartData" @head-confirm-edit="headConfirmEditFn"
      @head-cancel-edit="headCancelEditFn" :isHomeEdit="isHomeEdit"></home-header>
    <!-- 进度条 -->
    <div class="progress-box" v-show="isProgress">
      <progress-bar :progress="progress" :strokeWidth="20" :showInfo="true"></progress-bar>
    </div>
    <!-- 单机 -->
    <stand-alone v-if="!$store.state.isHome" :isEdit="isHomeEdit"></stand-alone>
    <!-- 底部 -->
    <div class="footer-bg" :class="{ indexDisable: isHomeEdit }"></div>
    <!-- 权限管理弹窗笼罩层 -->
    <!-- <viewspopup :showCover="adminTipShow" ></viewspopup> -->
    <div class="bg-cover" v-if="adminTipShow"></div>
    <!-- 权限管理弹窗 -->
    <div class="adminTip" v-if="adminTipShow">
      <div class="head">
        <div class="title">权限管理</div>
        <div class="icon" @click="adminTipOff"></div>
      </div>
      <div class="main">
        <div class="add_btn" @click="addTipFn">新增</div>
        <el-table :data="tableData" border style="width: 100% color: #fff" id="thead">
          <el-table-column label="序号" width="110" type="index"></el-table-column>
          <el-table-column prop="userName" label="用户名" width="300">
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" class="primary" @click="editTipFn(scope.$index, scope.row)">编辑</el-button>
              <el-button type="text" class="danger" @click="delTipFn(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <div class="edit" v-if="editTipShow">
      <div class="head">
        <div class="title">{{ editName }}</div>
        <div class="icon" @click="editTipOff"></div>
      </div>
      <div class="main">
        <div class="box">
          <span class="icon">*</span>
          <span>用户名</span>
          <input type="text" placeholder="请输入用户名" v-model="userInfo.userName" />
        </div>
        <div class="box">
          <span class="icon">*</span>
          <span>密码</span>
          <input type="password" placeholder="请输入密码" v-model="userInfo.userPassword" />
        </div>
        <div class="edit_btn">
          <div class="btn_box" @click="editFn">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ThreeDimensional from "@/assets/three/ThreeDimensional";
import homeHeader from "@/components/header/header.vue";
import homeContainer from "@/components/container/container.vue";
import machineTip from "@/module/machineTip.vue";
import standAlone from "@/components/standAlone/container.vue";
import progressBar from "@/module/progress.vue";
import request from "@/assets/utils/request";
// api接口
import {
  machineList,
  MTypeQuery,
  MTypeUpdate,
  DeviceStates,
} from "@/assets/api/chartData";
import { userQuery, userAdd, userUpdate, userDelete, titleQuery,machineStatus} from "@/assets/api/feedingStyle";
/*修改element-ui单出层的zIndex=30000*/
import PopupManager from "element-ui/lib/utils/popup/popup-manager";
PopupManager.zIndex = 30000;
/*end修改element-ui单出层的zIndex=30000*/
var ThreeDimen;
export default {
  components: {
    homeHeader,
    homeContainer,
    standAlone,
    machineTip,
    progressBar,
  },
  data() {
    return {
      isHome: false,
      //模拟数据
      machineList: {
        chargingSystemFileds: {
          name: "上料系统",
          list: [
            {
              name: "公转速度",
              key: "zousu",
              type: 1,
              value: "100RPM",
            },
            {
              name: "自转速度",
              key: "yali",
              value: "100RPM",
              type: 1,
            },
            {
              name: "搅拌温度",
              key: "houdu",
              value: "100°C",
              type: 1,
            },
            {
              name: "真空值",
              key: "jianxi",
              value: "100kpa",
              type: 0,
            },
            {
              name: "搅拌频率",
              key: "yeya",
              value: "100",
              type: 0,
            },
            {
              name: "搅拌最大速度",
              key: "state",
              value: "100rpm/min",
              type: 0,
            },
          ],
        },
        mixerFileds: {
          name: "搅拌机",
          list: [
            {
              name: "公转速度",
              key: "zousu",
              type: 1,
              value: "100RPM",
            },
            {
              name: "自转速度",
              key: "yali",
              value: "100RPM",
              type: 1,
            },
            {
              name: "搅拌温度",
              key: "houdu",
              value: "100°C",
              type: 1,
            },
            {
              name: "真空值",
              key: "jianxi",
              value: "100kpa",
              type: 0,
            },
            {
              name: "搅拌频率",
              key: "yeya",
              value: "100",
              type: 0,
            },
            {
              name: "搅拌最大速度",
              key: "state",
              value: "100rpm/min",
              type: 0,
            },
          ],
        },
        coaterFileds: {
          name: "涂布机",
          list: [
            {
              name: "自动运行速度",
              key: "zousu",
              type: 1,
              value: "100m/min",
            },
            {
              name: "螺旋泵速度",
              key: "yali",
              value: "100rpm/min",
              type: 1,
            },
            {
              name: "涂布长度",
              key: "houdu",
              value: "100m",
              type: 1,
            },
            {
              name: "留白宽度",
              key: "jianxi",
              value: "100um",
              type: 0,
            },
            {
              name: "烘箱温度",
              key: "yeya",
              value: "100°C",
              type: 0,
            },
            {
              name: "放卷张力",
              key: "state",
              value: "100N",
              type: 0,
            },
          ],
        },
        rollerPressFileds: {
          name: "辊压机",
          list: [
            {
              name: "左辊间隙",
              key: "zousu",
              type: 1,
              value: "100um",
            },
            {
              name: "液压压力",
              key: "yali",
              value: "100N",
              type: 1,
            },
            {
              name: "设备状态",
              key: "houdu",
              value: "100",
              type: 1,
            },
            {
              name: "运行速度",
              key: "jianxi",
              value: "100m/min",
              type: 0,
            },
            {
              name: "备用",
              key: "yeya",
              value: "100",
              type: 0,
            },
            {
              name: "备用",
              key: "state",
              value: "100",
              type: 0,
            },
          ],
        },
        slitterFileds: {
          name: "分条机",
          list: [
            {
              name: "自动运行速度",
              key: "zousu",
              type: 1,
              value: "100m/min",
            },
            {
              name: "极片宽度",
              key: "yali",
              value: "100mm",
              type: 1,
            },
            {
              name: "放卷张力",
              key: "houdu",
              value: "100N",
              type: 1,
            },
            {
              name: "收卷张力",
              key: "jianxi",
              value: "100N",
              type: 0,
            },
            {
              name: "备用",
              key: "yeya",
              value: "100",
              type: 0,
            },
            {
              name: "备用",
              key: "state",
              value: "100",
              type: 0,
            },
          ],
        },
        dieCuttingFileds: {
          name: "模切机",
          list: [
            {
              name: "冲压速度",
              key: "zousu",
              type: 1,
              value: "100p/min",
            },
            {
              name: "牵引速度",
              key: "yali",
              value: "100m/min",
              type: 1,
            },
            {
              name: "放卷张力",
              key: "houdu",
              value: "100N",
              type: 1,
            },
            {
              name: "收卷张力",
              key: "jianxi",
              value: "100N",
              type: 0,
            },
            {
              name: "生产效率",
              key: "yeya",
              value: "100",
              type: 0,
            },
            {
              name: "备用",
              key: "state",
              value: "100",
              type: 0,
            },
          ],
        },
        stackFileds: {
          name: "叠片机",
          list: [
            {
              name: "设备效率",
              key: "zousu",
              type: 1,
              value: "100",
            },
            {
              name: "机械手速度",
              key: "yali",
              value: "100",
              type: 1,
            },
            {
              name: "备用",
              key: "houdu",
              value: "100",
              type: 1,
            },
            {
              name: "备用",
              key: "jianxi",
              value: "100",
              type: 0,
            },
            {
              name: "备用",
              key: "yeya",
              value: "100",
              type: 0,
            },
            {
              name: "备用",
              key: "state",
              value: "100",
              type: 0,
            },
          ],
        },
        readyWeldFileds: {
          name: "预焊机",
          list: [
            {
              name: "预焊功率",
              key: "zousu",
              type: 1,
              value: "100w",
            },
            {
              name: "电压",
              key: "yali",
              value: "100v",
              type: 1,
            },
            {
              name: "超声波频率",
              key: "houdu",
              value: "100Hz",
              type: 1,
            },
            {
              name: "预焊时间",
              key: "jianxi",
              value: "100s",
              type: 0,
            },
            {
              name: "预焊冷却",
              key: "yeya",
              value: "100",
              type: 0,
            },
            {
              name: "备用",
              key: "state",
              value: "100",
              type: 0,
            },
          ],
        },
        finalWeldFileds: {
          name: "终焊机",
          list: [
            {
              name: "预焊功率",
              key: "zousu",
              type: 1,
              value: "100w",
            },
            {
              name: "电压",
              key: "yali",
              value: "100v",
              type: 1,
            },
            {
              name: "超声波频率",
              key: "houdu",
              value: "100Hz",
              type: 1,
            },
            {
              name: "预焊时间",
              key: "jianxi",
              value: "100s",
              type: 0,
            },
            {
              name: "预焊冷却",
              key: "yeya",
              value: "100",
              type: 0,
            },
            {
              name: "备用",
              key: "state",
              value: "100",
              type: 0,
            },
          ],
        },
        sealingTestFileds: {
          name: "顶侧封机",
          list: [
            {
              name: "终焊功率",
              key: "zousu",
              type: 1,
              value: "100w",
            },
            {
              name: "电压",
              key: "yali",
              value: "100v",
              type: 1,
            },
            {
              name: "超声波频率",
              key: "houdu",
              value: "100Hz",
              type: 1,
            },
            {
              name: "终焊功率",
              key: "jianxi",
              value: "100s",
              type: 0,
            },
            {
              name: "预焊冷却",
              key: "yeya",
              value: "100",
              type: 0,
            },
            {
              name: "备用",
              key: "state",
              value: "100",
              type: 0,
            },
          ],
        },
        hotplateFileds: {
          name: "真空烘烤机",
          list: [
            {
              name: "A层温度",
              key: "zousu",
              type: 1,
              value: "100°C",
            },
            {
              name: "B层温度",
              key: "yali",
              value: "100°C",
              type: 1,
            },
            {
              name: "A层真空值",
              key: "houdu",
              value: "100pa",
              type: 1,
            },
            {
              name: "B层真空值",
              key: "jianxi",
              value: "100pa",
              type: 0,
            },
            {
              name: "真空泵气压",
              key: "yeya",
              value: "100pa",
              type: 0,
            },
            {
              name: "保压下限",
              key: "state",
              value: "100pa",
              type: 0,
            },
          ],
        },
        liquidInjectorFileds: {
          name: "注液机",
          list: [
            {
              name: "静止时间",
              key: "zousu",
              type: 1,
              value: "100s",
            },
            {
              name: "设备效率",
              key: "yali",
              value: "100%",
              type: 1,
            },
            {
              name: "注液前称重",
              key: "houdu",
              value: "100kg",
              type: 1,
            },
            {
              name: "真空值",
              key: "jianxi",
              value: "100pa",
              type: 0,
            },
            {
              name: "注液后称重",
              key: "yeya",
              value: "100kg",
              type: 0,
            },
            {
              name: "失液量",
              key: "state",
              value: "100kg",
              type: 0,
            },
          ],
        },
        formingFileds: {
          name: "化成机",
          list: [
            {
              name: "压合状态",
              key: "zousu",
              type: 1,
              value: "100",
            },
            {
              name: "点位异常",
              key: "yali",
              value: "100",
              type: 1,
            },
            {
              name: "设备运行状态",
              key: "houdu",
              value: "100",
              type: 1,
            },
            {
              name: "报警信息",
              key: "jianxi",
              value: "100",
              type: 0,
            },
            {
              name: "备用",
              key: "yeya",
              value: "100",
              type: 0,
            },
            {
              name: "备用",
              key: "state",
              value: "100",
              type: 0,
            },
          ],
        },
        sealingFileds: {
          name: "封口机",
          list: [
            {
              name: "上封刀温度",
              key: "zousu",
              type: 1,
              value: "100°C",
            },
            {
              name: "下封刀温度",
              key: "yali",
              value: "100°C",
              type: 1,
            },
            {
              name: "真空值",
              key: "houdu",
              value: "100kpa",
              type: 1,
            },
            {
              name: "当前效率",
              key: "jianxi",
              value: "100%",
              type: 0,
            },
            {
              name: "封口时间",
              key: "yeya",
              value: "100s",
              type: 0,
            },
            {
              name: "封口次数 ",
              key: "state",
              value: "100",
              type: 0,
            },
          ],
        },
        sealingFileds: {
          name: "封口机",
          list: [
            {
              name: "上封刀温度",
              key: "zousu",
              type: 1,
              value: "100°C",
            },
            {
              name: "下封刀温度",
              key: "yali",
              value: "100°C",
              type: 1,
            },
            {
              name: "真空值",
              key: "houdu",
              value: "100kpa",
              type: 1,
            },
            {
              name: "当前效率",
              key: "jianxi",
              value: "100%",
              type: 0,
            },
            {
              name: "封口时间",
              key: "yeya",
              value: "100s",
              type: 0,
            },
            {
              name: "封口次数 ",
              key: "state",
              value: "100",
              type: 0,
            },
          ],
        },
        pressureFormingFileds: {
          name: "负压化成机",
          list: [
            {
              name: "上封刀温度",
              key: "zousu",
              type: 1,
              value: "100°C",
            },
            {
              name: "下封刀温度",
              key: "yali",
              value: "100°C",
              type: 1,
            },
            {
              name: "真空值",
              key: "houdu",
              value: "100kpa",
              type: 1,
            },
            {
              name: "当前效率",
              key: "jianxi",
              value: "100%",
              type: 0,
            },
            {
              name: "封口时间",
              key: "yeya",
              value: "100s",
              type: 0,
            },
            {
              name: "封口次数 ",
              key: "state",
              value: "100",
              type: 0,
            },
          ],
        },
      },
      // 多选列表
      machineData: {
        name: "",
        list: [],
      },
      // 显示数据
      machineInfo: [],
      // 进入编辑模式
      isHomeEdit: false,
      // 单机数据
      standAloneData: {},
      // 进度条
      progress: 0,
      isProgress: true,
      // 卷绕机
      switchMachine: false,
      // 是否有车间遮罩
      isShade: false,
      cMType: 0,
      //定义一个接口得数组
      MCArray: [
        "chargingSystem",
        "mixer",
        "coater",
        "rollerPress",
        "slitter",
        "dieCutting",
        "stack",
        "readyWeld",
        "finalWeld",
        "hotplate",
        "liquidInjector",
        "forming",
        "sealing",
        "sealingTest",
        "winder",
      ],
      //定义一个机器型号得接口
      MCId: [
        "MC001",
        "MC002",
        "MC003",
        "MC004",
        "MC005",
        "MC006",
        "MC007",
        "MC008",
        "MC009",
        "MC010",
        "MC011",
        "MC012",
        "MC013",
        "MC014",
        "MC015",
        "MC016",
      ],
      adminTipShow: false,
      tableData: [],
      projectName: "",
      // 用户更新数据
      userInfo: {
        projectList: [],
        userAccess: 0,
        userCompany: "",
        userId: 0,
        userName: "",
        userPassword: "",
      },
      userData: {},
      loggingShow: false,
      editTipShow: false,
      // 用户列表
      userList: [],
      //头部标题
      title: "",
      Machindata:"",
    };
  },
  created() {
    this.$bus.on("switch", () => {
      this.isProgress = true;
    });
  },
  mounted() {
    this.userData = JSON.parse(sessionStorage.getItem("userInfo"));
    this.$bus.on("bus-logging", () => {
      this.loggingShow = true;
    });
    let self = this;
    
    window.cMType = this.cMType;
    window.getMCid = this.getMCid;
    window.getProgress = this.getProgress;
    window.ClearScene_index = this.ClearScene_index;
    let arr = Object.keys(this.machineList).map((v) => v);
    this.$nextTick(() => {
      this.getcMType(arr);
      this.getChartData();
      this.getMachineStatus();
    });
    self.getMachineList();
    //定时器每俩秒请求一次所有机器数据
    setTimeout(() => {
      setInterval(() => {
        self.getMachineList();
      }, 5000);
    }, 1000);
    this.getTitle();
    //添加水印
    this.addWaterMarker();
  },
  methods: {
    //添加水印
    addWaterMarker() {
      let img = new Image();
      img.setAttribute("crossOrigin", 'Anonymous');
      img.src = "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/images/waterMark.png";
      var can = document.createElement('canvas');
      var watermark = document.getElementById('watermark');
      watermark.appendChild(can);
      can.width = 376; //画布的宽
      can.height = 282;//画布的高度
      can.style.display = 'none';
      var cans = can.getContext('2d');
      img.onload = () => {
        cans.drawImage(img, 50, 0, 180, 140);
        watermark.style.backgroundImage = "url(" + can.toDataURL("image/png") + ")"; //把画布插入到body中
        watermark.style.opacity = 0.3;
      }
    },
    //获取头部标题
    async getTitle() {
      let title = await titleQuery();
      this.title = title.data;
    },
    //新增用户
    addUser() {
      this.userInfo.userPassword = this.$Base64.encode(
        this.userInfo.userPassword
      );
      this.userInfo.userAccess = 2;
      userAdd(this.userInfo).then((res) => {
        if (res.code == 200) {
          this.$message.success("添加成功");
          // 获取用户列表
          this.getUserInfo();
          this.editTipOff();
        } else if (res.data.code == 405) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("添加失败,请检查");
        }
      });
    },
    //用户删除
    async userDelete(userId) {
      let res = await userDelete(userId);
      if (res.code == "200") {
        // 获取用户列表
        this.getUserInfo();
        this.$message.success("删除成功");
      } else {
        this.$message.error("删除失败，请检查");
      }
    },
    //查询到用户
    async getUserInfo() {
      let res = await userQuery();
      this.userList = res.data;
      this.tableData = this.userList.filter((v) => v.userAccess === 2);
      this.adminTipShow = true;
    },
    //修改用户
    async userUpdata() {
      this.userInfo.userPassword = this.$Base64.encode(
        this.userInfo.userPassword
      );
      let res = await userUpdate(this.userInfo);
      if (res.code == 200) {
        this.$message.success("修改成功");
        // 获取用户列表
        this.getUserInfo();
        this.editTipOff();
      } else {
        this.$message.error("修改失败,请检查");
      }
    },
    // 管理弹窗关闭
    adminTipOff() {
      this.adminTipShow = false;
      this.$store.commit("isShowUpdate", false);
    },
    // 编辑弹窗关闭
    editTipOff() {
      this.editTipShow = false;
    },
    // 用户新增
    addTipFn() {
      this.editName = "新增用户";
      this.userInfo = {};
      this.projectName = "";
      this.editTipShow = true;
    },
    // 用户编辑
    editTipFn(i, row) {
      row.userPassword = this.$Base64.decode(row.userPassword);
      this.editName = "编辑用户";
      this.userInfo = {
        ...row,
      };
      this.editTipShow = true;
    },
    //确认修改
    editFn() {
      if (this.editName == "新增用户") {
        this.addUser();
      } else {
        this.userUpdata();
      }
    },
    // 用户删除
    delTipFn(row) {
      // this.userDelete(row.uuid);
      this.$confirm("是否删除用户", "提示", {
        customClass: "message-logout",
      })
        .then(() => {
          this.userDelete(row.uuid);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    loggingOff() {
      this.loggingShow = false;
    },
    // head按钮切换
    getHomeModel(b) {
      this.isProgress = b; // Boolean
      let arr = Object.keys(this.machineList).map((v) => v);
      if (!b) {
        // 首页
        this.$nextTick(() => {
          this.getcMType(arr);
        });
      } else {
        // 车间遮罩
        this.isShade = false;
        // 统计分析
        // this.getChartData();
        ThreeDimen.clearScene();
      }
    },
    getMCid(index, cMType) {
      this.$store.commit("incrementFive", index);
      this.$store.commit("homeTab", false);
      this.$store.commit("flagUpdate", cMType);
      this.getHomeModel(true);
    },
    //统计分析初始数据获取
    async getChartData() {
      let res = await this.machine("chargingSystem", "MC001");
      this.$store.commit("dataUpdate", res.data);
    },
    machine(arrId, MCId) {
      return request({
        url: "/machine/" + arrId + "/chart?machineId=" + MCId,
        method: "get",
        data: {},
      });
    },
    //获取机器得所有数据
    async getMachineList() {
      let res = await machineList();
      this.machineList.chargingSystemFileds = res.data.chargingSystemFileds;
      this.machineList.mixerFileds = res.data.mixerFileds;
      this.machineList.coaterFileds = res.data.coaterFileds;
      this.machineList.rollerPressFileds = res.data.rollerPressFileds;
      this.machineList.slitterFileds = res.data.slitterFileds;
      this.machineList.dieCuttingFileds = res.data.dieCuttingFileds;
      this.machineList.stackFileds =
        this.cMType == 1 ? res.data.stackFileds : res.data.winderFileds;
      this.machineList.readyWeldFileds = res.data.readyWeldFileds;
      this.machineList.sealingTestFileds = res.data.sealingTestFileds;
      this.machineList.hotplateFileds = res.data.hotplateFileds;
      this.machineList.liquidInjectorFileds = res.data.liquidInjectorFileds;
      this.machineList.formingFileds = res.data.formingFileds;
      this.machineList.sealingFileds = res.data.sealingFileds;
      this.machineList.finalWeldFileds = res.data.finalWeldFileds;
      this.machineList.pressureFormingFileds = res.data.pressureFormingFileds;
      if (ThreeDimen) {
        this.getDeviceStates();
        this.getMachineStatus();       
        window.cMType = this.cMType;
        ThreeDimen.SetcMType_out(this.cMType);
        ThreeDimen.getMachineMove();
      }
      tipGetData();
    },
    // 进入编辑模式
    userFn() {
      this.isHomeEdit = true;
      if (this.$store.state.isHome) {
        ThreeDimen.EnterEditor();
        this.switchMachine = this.cMType == 0 ? true : false;
        //console.log("首页进入编辑模式-------");
      } else {
        //console.log("统计分析页面进入编辑模式");
      }
    },
    // 确认编辑
    headConfirmEditFn() {
      this.isHomeEdit = false;
      ThreeDimen.ExitEditor();
      this.isShade = false;
    },
    // 取消编辑
    headCancelEditFn() {
      // 弃用
      // this.isHomeEdit = false;
      // ThreeDimen.ExitEditor();
      // this.isShade = false;
    },
    // 获取进度条数据
    getProgress(item) {
      let self = this;
      this.progress = item;
      if ((item) => 99) {
        this.progress = 99;
        setTimeout(() => {
          self.progress = 100;
          setTimeout(() => {
            self.isProgress = false;
            self.progress = 0;
          }, 500);
        }, 2100);
      }
    },
    // 是否卷绕机
    switchMachineFn1() {
      this.switchMachine = false;
      //console.log("否卷绕机");
      this.postcMType(1, 0);
      //ThreeDimen.Change5Model(false);
    },
    switchMachineFn2() {
      this.switchMachine = true;
      //console.log("是卷绕机");
      this.postcMType(0, 1);
      //ThreeDimen.Change5Model(true);
    },
    // 关闭车间遮罩
    shadeFn() {
      this.isShade = false;
      ThreeDimen.ShowWorkShop(this.isShade);
      //console.log("关闭遮罩");
    },
    // 打开遮罩
    shadeShowFn() {
      this.isShade = true;
      ThreeDimen.ShowWorkShop(this.isShade);
      //console.log("打开遮罩");
    },
    //查询是否卷绕机
    getcMType(arr) {
      MTypeQuery().then((res) => {
        this.cMType = res.data[0].machineCategory;
        if (arr) {
          ThreeDimen = new ThreeDimensional("home-canvas");
          ThreeDimen.GetDivArray(arr);
        }
      });
    },
    getDeviceStates() {
      DeviceStates().then((res) => {
        //console.log(res);
        let arr = [
          //上料系统机器状态
          res.data.chargingSystemState,
          //搅拌机机器状态
          res.data.mixerState,
          //涂布机机器状态
          res.data.coaterState,
          //辊压机机器状态
          res.data.rollerPressState,
          //分条机机器状态
          res.data.slitterState,
          //模切机机器状态
          res.data.dieCuttingState,
          //叠片机机器状态 / 卷绕机
          this.cMType == 1 ? res.data.stackState : res.data.winderState,
          //预焊机机器状态
          res.data.readyWeldState,
          //终焊机
          res.data.finalWeldState,
          //封口测试一体机机器状态
          res.data.sealingTestState,
          //烘烤机机器状态
          res.data.hotplateState,
          //注液预封机机器状态
          res.data.liquidInjectorState,
          //化成机机器状态
          res.data.formingState,
          //抽气二封机机器状态
          res.data.sealingState,
        ];
        ThreeDimen.SetTips(arr);
        arr = null;
      });
    },
    //修改是否卷绕机
    postcMType(x, y) {
      let f = [
        {
          machineCategory: x,
          machineId: "MC007",
          machineName: "叠片机",
        },
        {
          machineCategory: y,
          machineId: "MC015",
          machineName: "卷绕机",
        },
      ];
      this.cMType = x;
      ThreeDimen.SetcMType_out(this.cMType);
      MTypeUpdate(f).then((res) => {
        //console.log(res.data);
      });
    },
    //获取机器动画开关数据
    async getMachineStatus() {
      let { data } = await machineStatus();
      this.Machindata = data;
      window.animaType = this.Machindata;
      //console.log(this.Machindata);
    },
    handleChildValue() {
      // 这里可以接收到子组件传递过来的值
      this.isShade = false;
      if (ThreeDimen) {
        ThreeDimen.clearScene();
      }
    },
    ClearScene_index() {
      if (ThreeDimen) {
        ThreeDimen.clearScene();
      }
    },
  },
};
//
</script>
<style src="./index.css" />
<style scoped leng="less">
 #watermark {
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
    /* 上层加上这句样式可以实现点击穿透 */
    float: left;
  }
/* 权限管理弹窗笼罩层样式 */
.bg-cover {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 98;
}

/*end 权限管理弹窗笼罩层 */

.adminTip /deep/ .el-table .cell {
  color: white !important;
  text-align: center;
  font-size: 1.0625rem;
}
</style>
<style lang="less">
.adminTip {
  position: fixed;
  top: 30%;
  left: 23.2%;
  width: 1000px;
  height: 450px;
  background: linear-gradient(360deg,
      rgba(0, 30, 45, 0.65) 0%,
      rgba(1, 69, 103, 0.85) 100%);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  border-image: linear-gradient(180deg,
      rgba(16, 176, 255, 0),
      rgba(36, 216, 255, 0.45)) 1 1;
  backdrop-filter: blur(6px);
  cursor: default;
  z-index: 9999;

  .head {
    width: 100%;
    height: 72px;
    background: rgba(0, 149, 255, 0.1);
    border-top: 3px solid;
    border-image: linear-gradient(90deg, #24d8ff 0%, #0095ff 100%) 1 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;

    .title {
      font-size: 20px;
      font-family: Gothic;
      font-weight: 600;
      color: #ffffff;
    }

    .icon {
      width: 20px;
      height: 20px;
      background: url("./image/icon_close.png") no-repeat center center;
      background-size: 100%;
      cursor: pointer;
    }
  }

  .main {
    height: calc(100% - 72px);
    padding: 15px 24px 32px;
    border: 1px solid;
    background-color: rgba(0, 0, 0, 0);
    // background-color: pink;
    border-image: linear-gradient(180deg,
        rgba(16, 176, 255, 0),
        rgba(36, 216, 255, 0.45)) 1 1;

    .add_btn {
      width: 100px;
      height: 36px;
      margin-bottom: 12px;
      background: rgba(4, 18, 25, 0.45) linear-gradient(90deg,
          rgba(16, 176, 255, 0.45) 0%,
          rgba(16, 176, 255, 0.25) 100%);
      border: 1px solid #24d8ff;
      font-size: 16px;
      font-family: Gothic;
      font-weight: 400;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
    }

    #thead {
      height: calc(100% - 48px);
      background-color: rgba(0, 0, 0, 0);
    }
  }
}

.edit {
  position: fixed;
  top: 35%;
  left: 35%;
  width: 660px;
  height: 450px;
  background: linear-gradient(360deg,
      rgba(0, 30, 45, 0.65) 0%,
      rgba(1, 69, 103, 0.85) 100%);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  border-top: 3px solid;
  border-image: linear-gradient(90deg, #24d8ff 0%, #0095ff 100%) 1 1;
  backdrop-filter: blur(6px);
  z-index: 9999;

  .head {
    width: 660px;
    height: 72px;
    background: rgba(0, 149, 255, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;

    .title {
      font-size: 20px;
      font-family: Gothic;
      font-weight: 600;
      color: #ffffff;
    }

    .icon {
      width: 20px;
      height: 20px;
      background: url("./image/icon_close.png") no-repeat center center;
      background-size: 100%;
      cursor: pointer;
    }
  }

  .main {
    height: calc(100% - 72px);
    padding: 15px 24px;
    border: 1px solid;
    border-image: linear-gradient(180deg,
        rgba(16, 176, 255, 0),
        rgba(36, 216, 255, 0.45)) 1 1;

    .box {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 80px;

      .icon {
        color: #ff5740;
      }

      span {
        font-size: 14px;
        font-family: Gothic;
        font-weight: 400;
        color: #ffffff;
      }

      input {
        width: 370px;
        height: 40px;
        margin: 8px 12px;
        color: #ffffff;
        padding-left: 10px;
        padding-right: 10px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(0, 0, 0, 0);

        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(255, 255, 255, 0.65);
          font-size: 14px;
          font-weight: 400;
          font-family: Gothic;
        }
      }

      select {
        width: 370px;
        height: 40px;
        margin: 8px 12px;
        color: #ffffff;
        padding-left: 10px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(0, 0, 0, 0);
      }
    }

    .edit_btn {
      width: 370px;
      height: 36px;
      margin-top: 20px;
      margin-left: 150px;
      background: linear-gradient(270deg,
          rgba(16, 176, 255, 0.25) 0%,
          rgba(36, 216, 255, 0.85) 100%);

      .btn_box {
        background-image: url("./image/icon_arrowright_white.png") no-repeat 200px center;
        background-size: 16px;
        font-size: 14px;
        font-family: Gothic;
        // font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
      }
    }
  }
}

.adminTip .el-table {
  background: rgba(0, 0, 0, 0);
  border: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.08);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 14px;
  font-family: Gothic;
  font-weight: 400;
}

.adminTip .el-table__header-wrapper {
  height: 40px;
  background: rgba(4, 18, 25, 0.25);
  font-size: 14px;
  font-family: Gothic;
  font-weight: 400;
  color: #ffffff;
}

.adminTip .el-table thead {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
}

.adminTip .el-table__header {
  width: 100% !important;
  height: 100%;
}

.adminTip .el-table tr {
  background: rgba(4, 18, 25, 0);
}

.adminTip .el-table th.el-table__cell.is-leaf {
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  text-align: center;
}

.adminTip .el-table--border .el-table__cell {
  border: 0;
}

.adminTip .el-table th.el-table__cell {
  background: rgba(0, 0, 0, 0);
  padding: 0;
}

.adminTip .el-table--border::after,
.adminTip .el-table--group::after,
.adminTip .el-table::before {
  background: rgba(0, 0, 0, 0);
}

// 移入效果
.adminTip .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
  background: rgba(0, 0, 0, 0);
}

.adminTip .el-table__body-wrapper {
  height: calc(100% - 40px);
  overflow: auto;
}

.adminTip .el-table__body {
  width: 100% !important;
}

.adminTip .el-table__row {
  height: 48px;
}

.adminTip .el-table .el-table__cell {
  padding: 0;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.adminTip .el-table--enable-row-transition .el-table__body td.el-table__cell {
  font-size: 14px;
  font-family: Gothic;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}

.adminTip .primary span {
  font-size: 14px;
  font-family: Gothic;
  font-weight: 400;
  color: #24d8ff;
}

.adminTip .danger span {
  font-size: 14px;
  font-family: Gothic;
  font-weight: 400;
  color: #ff5740;
}

.edit .el-select {
  width: 370px;
  height: 40px;
  margin: 8px 12px;
  position: relative;

  .el-input__inner {
    background: rgba(4, 18, 25, 0);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 0;
    color: #fff;
  }

  .el-input__inner:hover {
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .el-input__inner:focus {
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
}

.edit .el-range-editor.is-active,
.edit .el-range-editor.is-active:hover,
.edit .el-select .el-input.is-focus .el-input__inner {
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.edit .el-select-dropdown {
  position: absolute !important;
  top: 10 !important;
  left: 0 !important;
  background: rgba(4, 18, 25, 0.85) linear-gradient(90deg,
      rgba(16, 176, 255, 0.45) 0%,
      rgba(16, 176, 255, 0.25) 100%);
  position: absolute;
  z-index: 1001;
  border: 0;
  box-sizing: border-box;

  .popper__arrow {
    border-bottom-color: #0a5982 !important;
  }

  .popper__arrow::after {
    border-bottom-color: #0a5982 !important;
  }

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background: #2aaefc;
    color: #fff;
  }

  .el-select-dropdown__item {
    color: rgba(255, 255, 255, 0.8);
  }
}

.message-logout {
  font-family: Gothic !important;
  text-align: center !important;

  .el-message-box__btns {
    margin-top: 10px;
    text-align: center;
  }
  .el-message-box__title{
    color: #fff;
  }
  .el-message-box__message{
    color: #fff;
  }
}

.el-message-box {
  background: rgba(4, 18, 25, 0.85) linear-gradient(90deg,
      rgba(16, 176, 255, 0.45) 0%,
      rgba(16, 176, 255, 0.25) 100%) !important;
  border: 0 !important;
  color: #fff !important;

  .el-button {
    span {
      font-family: Gothic !important;
      color: #000;
    }
  }

  .el-button--primary {
    span {
      color: #fff;
    }
  }
}
</style>
